module.exports = __webpack_public_path__ + "img/icon_close.e8d0cba9.svg";